import React from 'react';
import { useIntl } from 'react-intl';
import { Alert, ModalBody, ModalFooter } from 'reactstrap';
import { TypedMemo } from '../../../common/types';
import { MasterCheck } from '../songUpload';
import { soundCloudUploadMessages as m } from '../soundCloudMessages';
import { withBrandWord } from '../../components/primitives/BrandWord';

interface SongUploadMasterCheckProps {
  check: Exclude<MasterCheck, null>;
  onOpenSongPage: () => void;
}

const TEXT = { missing: m.masterMissing, processing: m.masterProcessing, failed: m.masterFailed };

/**
 * The master check (design c5): the song has no usable master, so the form does not show and
 * Upload stays off. While the master processes, `catalog.song.updated` reads the defaults again
 * and the form opens by itself.
 */
const SongUploadMasterCheckComponent: React.FC<SongUploadMasterCheckProps> = ({ check, onOpenSongPage }) => {
  const intl = useIntl();
  return (
    <>
      <ModalBody data-testid={`song-upload-master-${check}`}>
        <Alert color={check === 'processing' ? 'info' : 'danger'} className="mb-0">
          {withBrandWord(intl.formatMessage(TEXT[check]))}
        </Alert>
      </ModalBody>
      <ModalFooter>
        {check !== 'processing' && (
          <button type="button" className="btn btn-outline-secondary" onClick={onOpenSongPage}>
            {intl.formatMessage(m.openSongPage)}
          </button>
        )}
        <button type="button" className="btn btn-primary" disabled>
          {intl.formatMessage(m.upload)}
        </button>
      </ModalFooter>
    </>
  );
};

export const SongUploadMasterCheck = TypedMemo(SongUploadMasterCheckComponent);
